if (!customElements.get('customer-apply-email')) {
  customElements.define(
    'customer-apply-email',
    class CustomerApplyEmail extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.populateEmailFromUrl();
      }

      populateEmailFromUrl() {
        const params = new URLSearchParams(window.location.search);
        let email = params.get('email');
        if (email) {
          email = email.replace(/\s/g, '+');
          console.log('email=', email);
          const emailInput = document.querySelector('input[type="email"]');
          if (emailInput) {
            emailInput.value = email;
          }
        }
      }
    }
  );
}